import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { umsgCancelPayment } from 'bl/umsgs.bl';
import Button from 'components/form/Button.component';
import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';
import actionBe from 'utils/mw/actionBe.util';

const L = logger('UmsgPage');

const PID = 'dummy-intent-id';
const RID = 'dummy-reader-id';

const dummyAction = actionBe(
  'dummyAction',
  withOptions(({ AT, ATAG, umsg, readerId, paymentIntentId }) =>
    endpoint(H.post, 'payments/stripe/cancel/payment/:salonId/:readerId/', {
      AT,
      name: ATAG,
      params: { readerId },
      data: { intent_id: fromAnyToTrimmed(paymentIntentId) || null },
      pin: false,
      umsg,
    }),
  ),
);

const dumbestAction = actionBe(
  'dumbestAction',
  withOptions(({ AT, ATAG, umsg }) =>
    endpoint('GET', '', {
      AT,
      name: ATAG,
      base: 'https://localhost:-1/',
      pin: false,
      umsg,
    }),
  ),
);

const UmsgPage = ({ dummyAction, dumbestAction }) => {
  const handleCancel = useCallback(() => {
    dummyAction({
      readerId: RID,
      paymentIntentId: PID,
      umsg: { fn: umsgCancelPayment, arg: { intentId: PID } },
    })
      .then((r) => L.debug('handleCancel()', 'then()', 'r:', r))
      .catch((e) => L.debug('handleCancel()', 'catch()', 'e:', e));
  }, [dummyAction]);

  const handleError = useCallback(() => {
    dumbestAction({
      umsg: { fn: umsgCancelPayment },
    })
      .then((r) => L.debug('handleError()', 'then()', 'r:', r))
      .catch((e) => L.debug('handleError()', 'catch()', 'e:', e));
  }, [dumbestAction]);

  return (
    <div data-bem="UmsgPage">
      <Button onClick={handleCancel}>Try a cancel</Button>
      <Button onClick={handleError}>Try an error</Button>
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
const UmsgPageHoc = connect(null, (dispatch) => bindActionCreators({ dummyAction, dumbestAction }, dispatch))(UmsgPage);

export default UmsgPageHoc;
